// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Les modules de norme du FRONT — pendant de `normes/installees.py` côté serveur.
//
// Ajouter une norme (branche `module/<norme>`) = créer `modules/<norme>/` puis
// AJOUTER UNE LIGNE ici. Rien d'autre hors de son dossier.

import amiante from './amiante/locales';

// Libellés de chaque module, assemblés au catalogue par `i18n.js`.
// ⚠️ UN module PAR LIGNE : le contrôle de périmètre d'une branche `module/*`
// (scripts/perimetre_module.py) n'admet ici que des lignes AJOUTÉES qui nomment
// la norme — modifier une ligne existante serait refusé.
export const LIBELLES_MODULES = [
  amiante,
];
